<template>
  <div>
    <BlSheetMv
      :active.sync="isSheetOpen"
      auto-height
      :is-draggable="false"
      data-test="sheet-verification"
    >
      <BlFlexContainerMv
        slot="content"
        class="ph-12 mb-76"
        wrap="wrap"
        direction="column"
        align-items="center"
      >
        <img
          width="200px"
          height="124px"
          class="mb-24"
          src="../images/img_medium_mitra_ktp.png"
        />
        <BlTextAv class="ph-24 mb-8" variation="subheading-20">
          Verifikasi data diri dulu, yuk!
        </BlTextAv>
        <BlTextAv
          variation="body-14"
          color="secondary"
          class="ph-24 mb-16"
          style="text-align: center;"
          data-test="description"
        >
          Silakan ambil KTP-mu dan siap-siap selfie untuk verifikasi data diri.
        </BlTextAv>
      </BlFlexContainerMv>
      <div slot="footer" class="p-16" style="text-align: center;">
        <BlButtonAv
          variation="primary"
          fullwidth
          style="max-width: 280px;"
          data-test="action-btn"
          @click="handleActionClick"
        >
          Mulai verifikasi
        </BlButtonAv>
      </div>
    </BlSheetMv>
  </div>
</template>

<script>
import BlSheetMv from '@bukalapak/bazaar-mweb/dist/components/BlSheetMv';
import BlTextAv from '@bukalapak/bazaar-mweb/dist/components/BlTextAv';
import BlButtonAv from '@bukalapak/bazaar-mweb/dist/components/BlButtonAv';
import BlFlexContainerMv from '@bukalapak/bazaar-mweb/dist/components/BlFlexContainerMv';

const TRACKER_SCREEN_NAME = 'verification_onboarding_sheet';

// Fork from 'payment-services-digital-send/components/VerificationOnBoardingSheet.vue'
export default {
  components: {
    BlSheetMv,
    BlTextAv,
    BlButtonAv,
    BlFlexContainerMv,
  },
  props: {
    active: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isSheetOpen: {
      get() {
        return this.active;
      },
      set(newValue) {
        this.$emit('update:active', newValue);
      },
    },
  },
  watch: {
    active(newValue, oldValue) {
      // Track when sheet is closed (from true to false)
      if (oldValue === true && newValue === false) {
        this.trackSheetClose();
      }
    },
  },
  methods: {
    handleActionClick() {
      this.trackVerificationClick();
      this.$emit('action-click');
    },
    trackVerificationClick() {
      if (this.$tracker) {
        this.$tracker.itemMitraItemClickTrack({
          click_source: 'click-detail-verification',
          current_screen: TRACKER_SCREEN_NAME,
          target_screen: 'kyc_page',
        });
      }
    },
    trackSheetClose() {
      if (this.$tracker) {
        this.$tracker.itemMitraItemClickTrack({
          click_source: 'click-close-verification-sheet',
          current_screen: TRACKER_SCREEN_NAME,
          target_screen: 'item_detail_page',
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.mb-76 {
  margin-bottom: 76px;
}
</style>
